import type { IDocument } from '../Interfaces/IDocument';
import {
  type IMeetingEmailTemplate,
  meetingEmailTemplateSchema,
} from '../Interfaces/IMeetingEmailTemplate';
import {
  type ILegalTransactionMeetingEmail,
  legalTransactionMeetingEmailSchema,
} from '../Interfaces/ILegalTransactionMeetingEmail';

const getNextNegativeStart = (ids: number[]) => Math.min(0, ...ids) - 1;

const cloneDocuments = (documents: IDocument[] = []): IDocument[] => {
  let nextDocumentId = -1;

  return documents.map(document => ({
    ...document,
    idDocument: nextDocumentId--,
    idDocumentDirectory: null,
    idLegalTransaction: null,
  }));
};

export const copyTemplatesToTemplates = ({
  templates,
  existingTemplates,
  idLegalTransactionType,
}: {
  templates: IMeetingEmailTemplate[];
  existingTemplates: IMeetingEmailTemplate[];
  idLegalTransactionType: number | null;
}): IMeetingEmailTemplate[] => {
  let nextTemplateId = getNextNegativeStart(
    existingTemplates.map(template => template.idMeetingEmailTemplate)
  );

  return templates.map(template =>
    meetingEmailTemplateSchema.parse({
      ...template,
      idMeetingEmailTemplate: nextTemplateId--,
      idLegalTransactionType,
      Documents: cloneDocuments(template.Documents ?? []),
    })
  );
};

export const copyTemplatesToMeetingEmails = ({
  templates,
  existingMeetingEmails,
  idLegalTransactionMeeting,
  idLegalTransaction,
}: {
  templates: IMeetingEmailTemplate[];
  existingMeetingEmails: ILegalTransactionMeetingEmail[];
  idLegalTransactionMeeting: number;
  idLegalTransaction: number;
}): ILegalTransactionMeetingEmail[] => {
  let nextMeetingEmailId = getNextNegativeStart(
    existingMeetingEmails.map(email => email.idLegalTransactionMeetingEmail)
  );

  return templates.map(template =>
    legalTransactionMeetingEmailSchema.parse({
      ...template,
      idLegalTransactionMeetingEmail: nextMeetingEmailId--,
      idLegalTransactionMeeting,
      idLegalTransaction,
      Documents: cloneDocuments(template.Documents ?? []),
    })
  );
};

export const copyMeetingEmailsToMeetingEmails = ({
  meetingEmails,
  existingMeetingEmails,
  idLegalTransactionMeeting,
  idLegalTransaction,
}: {
  meetingEmails: ILegalTransactionMeetingEmail[];
  existingMeetingEmails: ILegalTransactionMeetingEmail[];
  idLegalTransactionMeeting: number;
  idLegalTransaction: number;
}): ILegalTransactionMeetingEmail[] => {
  let nextMeetingEmailId = getNextNegativeStart(
    existingMeetingEmails.map(email => email.idLegalTransactionMeetingEmail)
  );

  return meetingEmails.map(meetingEmail =>
    legalTransactionMeetingEmailSchema.parse({
      ...meetingEmail,
      idLegalTransactionMeetingEmail: nextMeetingEmailId--,
      idLegalTransactionMeeting,
      idLegalTransaction,
      Documents: cloneDocuments(meetingEmail.Documents ?? []),
    })
  );
};
